<template>
  <div id="app">
    <div v-if="environment != 'production'" id="nav">
      <router-link to="/select">Select Property</router-link> |
      <router-link to="/table">Table</router-link>
    </div>
    <router-view/>
    <el-footer v-if="environment != 'production'">
      <hr>
      <p><b>Environment:</b> {{ environment }} | <b>API Base:</b> {{ api_base }} | <b>Version:</b> {{ version }}</p><el-button @click="logout" v-if="loggedIn">Logout</el-button>
    </el-footer>
  </div>
</template>

<script>
import firebase from 'firebase'
import { mapGetters } from 'vuex'

export default {
  computed: {
    environment: function () {
      return process.env.NODE_ENV
    },
    version: function () {
      return process.env.VUE_APP_VERSION
    },
    api_base: function () {
      return process.env.VUE_APP_API_BASE
    },
    ...mapGetters({
      loggedIn: 'getLoggedIn'
    })
  },
  methods: {
    logout () {
      let self = this
      firebase.auth().signOut()
        .then(function () {
          console.log('loggedout')
          self.$store.commit('setLoggedOut')
          self.$router.push('/')
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
